export const paymentMethodsIcons = [
    '/assets/images/icons8-visa.svg',
    '/assets/images/icons8-mastercard.svg',
    '/assets/images/icons8-american-express.svg',
    '/assets/images/6129bac6-carnet.svg',
  ];